/**
 * @clone almost the same as in root project, except this one return complete IntersectionEntry
 * @param {Element} element
 * @param {object} [options]
 * @return {Promise<IntersectionObserverEntry>}
 * @todo does it need to use {@link https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver external polyfill}?
 */
export function getElementIntersection(element, options) {
  return new Promise((resolve) => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        resolve(entry);
      }

      observer.disconnect();
    }, options);

    observer.observe(element);
  });
}
